export enum DEALER_DOCUMENTATIONS_STORAGE_KEYS {
  CategoryPreference = "dealer-documentations-category-preference",
  DealerPreference = "dealer-documentations-dealer-preference",
  LocationPreference = "dealer-documentations-location-preference",
  VisibleToMechanicPreference = "dealer-documentations-visible-to-mechanic-preference"
}
